import React, { useEffect, useState } from "react";
import { Inbox, Loader2, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const ESTADOS = [["nueva", "Nueva", "bg-blue-100 text-blue-800"], ["contactada", "Contactada", "bg-amber-100 text-amber-800"], ["cerrada", "Cerrada", "bg-emerald-100 text-emerald-800"]];

export default function AdminLeads() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/leads").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const setEstado = async (id, estado) => {
    await api.patch(`/admin/leads/${id}`, { estado });
    toast.success("Estado actualizado");
    load();
  };
  return (
    <div className="p-8 fade-in" data-testid="admin-leads-page">
      <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Web pública · /informacion</div>
      <h1 className="font-display text-4xl font-extrabold mt-1 tracking-tight flex items-center gap-3"><Inbox size={30} /> Solicitudes de información</h1>
      <p className="text-slate-600 mt-1 text-sm mb-6">Cada solicitud se guarda aquí y te llega por email a pedro@archiduquecarlos.com.</p>
      {!rows ? <div className="text-slate-500 flex gap-2"><Loader2 className="animate-spin" size={16} /> Cargando…</div> : !rows.length ? (
        <div className="card p-10 text-center text-slate-500" data-testid="admin-leads-empty">Todavía no hay solicitudes.</div>
      ) : (
        <div className="card overflow-auto">
          <table className="dense" data-testid="admin-leads-table">
            <thead><tr><th>Fecha</th><th>Nombre</th><th>Farmacia</th><th>Contacto</th><th>Población</th><th>Interés</th><th>Comentarios</th><th>Estado</th></tr></thead>
            <tbody>
              {rows.map((l) => (
                <tr key={l.id} data-testid={`lead-row-${l.id}`}>
                  <td className="text-xs whitespace-nowrap">{new Date(l.created_at).toLocaleString("es-ES")}</td>
                  <td className="font-semibold">{l.nombre}</td>
                  <td>{l.farmacia}</td>
                  <td className="text-xs space-y-1">
                    {l.telefono && <a href={`tel:${l.telefono}`} className="flex items-center gap-1 text-blue-700"><Phone size={11} />{l.telefono}</a>}
                    {l.email && <a href={`mailto:${l.email}`} className="flex items-center gap-1 text-blue-700"><Mail size={11} />{l.email}</a>}
                  </td>
                  <td className="text-xs">{l.poblacion || "—"}</td>
                  <td className="text-xs">{l.interes || "—"}</td>
                  <td className="text-xs max-w-xs">{l.comentarios || "—"}</td>
                  <td>
                    <select value={l.estado} onChange={(e) => setEstado(l.id, e.target.value)} data-testid={`lead-estado-${l.id}`}
                            className={"text-xs font-semibold rounded-full px-2 py-1 border-0 " + (ESTADOS.find((s) => s[0] === l.estado)?.[2] || "")}>
                      {ESTADOS.map(([v, t]) => <option key={v} value={v}>{t}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
